import { Link } from "react-router-dom";

const Footer = () => {
  const goToTop = () => {
    window.scrollTo(0, 0);
  };

  const openSubmenuFooter = (linkRedirectUrl, event) => {
    if (event) {
      event.preventDefault();
    }
    if (window.innerWidth > 768) {
      window.location.href = linkRedirectUrl;
    } else {
      const submenuParent = event.currentTarget.parentNode;
      submenuParent.classList.toggle("active");
    }
  };

  return (
    <footer className="v-footer">
      <div className="to-top">
        {/* <!-- v-align-c --> */}
        <span className="v-align-c" onClick={goToTop}>
          De vuelta al inicio
          <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 10l5.5 5.5L18 10"
              fill="none"
              stroke="currentColor"
            ></path>
          </svg>
        </span>
      </div>
      <div className="sections">
        <ul className="sections__ul">
          <li className="sections__li">
            <div className="sections__title">
              {/* <!--<a href="https://www.audi.com.mx/es/experiencia/carta-bienvenida/" target="_self">--> */}
              <Link
                to="/"
                onClick={(event) => {
                  openSubmenuFooter(
                    "https://www.audi.com.mx/es/experiencia/carta-bienvenida/",
                    event
                  );
                  event.preventDefault();
                }}
              >
                <span>Experiencia</span>
                <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 10l5.5 5.5L18 10"
                    fill="none"
                    stroke="currentColor"
                  ></path>
                </svg>
              </Link>
            </div>
            <div className="sections__list">
              <ul>
                <li>
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/experiencia/carta-bienvenida/"
                    target="_self"
                  >
                    Menu
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com/en/sport/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Audi Sport
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/experiencia/promocAudi/"
                    target="_self"
                  >
                    Promociones
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="http://audi.com.mx/es/experiencia/newsletter/"
                    target="_self"
                  >
                    e-Newsletter
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/experiencia/internacional/"
                    target="_self"
                  >
                    Audi internacional
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/experiencia/go-green/"
                    target="_self"
                  >
                    Audi Go Green
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/experiencia/audi_rewards/"
                    target="_self"
                  >
                    Audi rewards
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/experiencia/temporadas/temporadas_podcast/"
                    target="_self"
                  >
                    Audi Podcast
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li className="sections__li">
            <div className="sections__title">
              {/* <!--<a href="https://www.audi.com.mx/es/servicios-al-cliente/" target="_self">--> */}
              <Link
                to="/"
                onClick={(event) => {
                  openSubmenuFooter(
                    "https://www.audi.com.mx/es/servicios-al-cliente/",
                    event
                  );
                  event.preventDefault();
                }}
              >
                <span>Servicios al cliente</span>
                <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 10l5.5 5.5L18 10"
                    fill="none"
                    stroke="currentColor"
                  ></path>
                </svg>
              </Link>
            </div>
            <div className="sections__list">
              <ul>
                <li>
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/"
                    target="_self"
                  >
                    Menu
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/audi-contigo/"
                    target="_self"
                  >
                    Audi contigo
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/Audi_Financial_Services/Audi_now/"
                    target="_self"
                  >
                    Audi Financial Services
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/atencion_a_clientes/"
                    target="_self"
                  >
                    Atención a clientes
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/audi_connect/"
                    target="_self"
                  >
                    Audi Connect
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/postventa/"
                    target="_self"
                  >
                    Servicio Audi
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/Audi_Corporate/"
                    target="_self"
                  >
                    Audi Corporate
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/garantia_extendida/"
                    target="_self"
                  >
                    Garantía Extendida
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/Audi_plus/"
                    target="_self"
                  >
                    Audi Plus
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-airbag/"
                    target="_self"
                  >
                    Llamado a revisión de bolsas de aire
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-revision/"
                    target="_self"
                  >
                    Llamado a revisión general
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/servicios-al-cliente/audi_waiting/"
                    target="_self"
                  >
                    Delivery situation
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li className="sections__li">
            <div className="sections__title">
              {/* <!--<a href="https://www.audi.com.mx/es/premium-used-car/" target="_self">--> */}
              <Link
                to="/"
                onClick={(event) => {
                  openSubmenuFooter(
                    "https://www.audi.com.mx/mx/web/es/certified-plus/certified.html",
                    event
                  );
                  event.preventDefault();
                }}
              >
                <span>Audi Certified :plus</span>
                <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 10l5.5 5.5L18 10"
                    fill="none"
                    stroke="currentColor"
                  ></path>
                </svg>
              </Link>
            </div>
            <div className="sections__list">
              <ul>
                <li>
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/premium-used-car/"
                    target="_self"
                  >
                    Menu
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/certified-plus/certified/"
                    target="_self"
                  >
                    Audi Certified :plus
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/certified-plus/certified/concesionarios_audi_certified_plus/"
                    target="_self"
                  >
                    Concesionarios Audi Certified :plus
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li className="sections__li">
            <div className="sections__title">
              {/* <!--<a href="https://www.audi.com.mx/es/audi-en-mexico/" target="_self">--> */}
              <Link
                to="/"
                onClick={(event) => {
                  openSubmenuFooter(
                    "https://www.audi.com.mx/es/compania/",
                    event
                  );
                  event.preventDefault();
                }}
              >
                <span>Compañía</span>
                <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 10l5.5 5.5L18 10"
                    fill="none"
                    stroke="currentColor"
                  ></path>
                </svg>
              </Link>
            </div>
            <div className="sections__list">
              <ul>
                <li data-is-overview-link="true">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/"
                    target="_self"
                  >
                    Menu
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/planta-de-audi-en-mexico/"
                    target="_self"
                  >
                    Audi México
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/planta-de-audi-en-mexico/comite-ejecutivo/"
                    target="_self"
                  >
                    Comité Ejecutivo
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/integridad-y-compliance/nuestro-codigo/"
                    target="_self"
                  >
                    Código de conducta
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/integridad-y-compliance/"
                    target="_self"
                  >
                    Integridad y Compliance (I&C)
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/sistema-de-denuncias/"
                    target="_self"
                  >
                    Sistema de denuncias
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/sustentabilidad/"
                    target="_self"
                  >
                    ESG
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/media-center/"
                    target="_self"
                  >
                    Media Center
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/carreras/"
                    target="_self"
                  >
                    Carreras
                  </a>
                </li>
                <li data-is-overview-link="false">
                  <a
                    className=""
                    href="https://www.audi.com.mx/es/audi-en-mexico/documentos-legales/"
                    target="_self"
                  >
                    Documentos legales
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div className="c-social v-align-c">
        {/* <!--<span className="v-align-c">
                De vuelta al inicio
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <path id="arrow_up" d="M11.249,8.581v10h2.087v-10l4.481,4.481,1.476-1.476-7-7-7,7,1.476,1.476Z" transform="translate(-5.293 -4.586)" fill="#c1cace"/>
                </svg>   
            </span>--> */}

        <div>
          <a
            href="https://www.facebook.com/AudideMexico"
            target="_blank"
            rel="noreferrer"
          >
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.768 15.737H12v3.315h3.768V29h4.422v-9.948h4.42v-3.315h-4.42v-1.335c0-1.002 1.053-3.087 2.589-3.087h1.831V8h-3.868c-5.457.795-4.974 7.737-4.974 7.737z"
                fill="currentColor"
              ></path>
            </svg>
          </a>
          <a
            href="https://www.instagram.com/audidemexico/"
            target="_blank"
            rel="noreferrer"
          >
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
              <g fill="currentColor">
                <path d="M18 10.621c2.403 0 2.688.01 3.637.053.877.04 1.354.188 1.671.31.42.162.72.359 1.035.672.316.316.51.615.672 1.035.123.318.27.795.311 1.673.043.948.052 1.233.052 3.636s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.8 2.8 0 01-.674 1.035c-.315.316-.615.51-1.035.672-.315.125-.792.27-1.67.311-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.787 2.787 0 01-1.036-.672 2.771 2.771 0 01-.671-1.036c-.125-.317-.27-.794-.311-1.67-.043-.95-.053-1.235-.053-3.638 0-2.403.01-2.688.053-3.637.04-.877.188-1.354.31-1.671.162-.42.359-.72.672-1.036.316-.315.615-.51 1.035-.671.318-.125.795-.27 1.673-.311.948-.043 1.233-.053 3.636-.053zM18 9c-2.445 0-2.751.01-3.711.054-.957.045-1.612.195-2.184.418a4.385 4.385 0 00-1.595 1.039 4.417 4.417 0 00-1.037 1.594c-.223.572-.376 1.227-.419 2.184C9.009 15.249 9 15.557 9 18c0 2.444.01 2.751.054 3.711.045.957.195 1.613.418 2.184.23.593.537 1.095 1.039 1.595a4.398 4.398 0 001.594 1.038c.572.222 1.227.375 2.184.418.96.045 1.268.054 3.711.054 2.444 0 2.751-.01 3.711-.054.957-.045 1.613-.195 2.184-.419a4.385 4.385 0 001.595-1.038 4.398 4.398 0 001.038-1.594c.222-.572.375-1.227.418-2.184.045-.96.054-1.267.054-3.711s-.01-2.751-.054-3.711c-.045-.957-.195-1.612-.419-2.184a4.412 4.412 0 00-1.038-1.595 4.41 4.41 0 00-1.594-1.037c-.572-.223-1.227-.376-2.184-.419C20.751 9.009 20.444 9 18 9z"></path>
                <path d="M18 13.379a4.622 4.622 0 100 9.243 4.622 4.622 0 000-9.243zM18 21a3 3 0 110-6 3 3 0 010 6z"></path>
                <circle cx="22.805" cy="13.195" r="1.08"></circle>
              </g>
            </svg>
          </a>
          <a
            href="https://www.youtube.com/user/AudideMexico"
            target="_blank"
            rel="noreferrer"
          >
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M28.79 13.58s-.206-1.448-.834-2.085c-.8-.837-1.695-.84-2.104-.89-2.94-.213-7.348-.213-7.348-.213h-.009s-4.408 0-7.347.213c-.41.05-1.304.053-2.104.89-.63.637-.834 2.085-.834 2.085S8 15.276 8 16.976v1.595c0 1.698.21 3.397.21 3.397s.205 1.447.834 2.085c.8.837 1.848.81 2.316.897 1.68.162 7.14.212 7.14.212s4.413-.006 7.35-.22c.412-.049 1.306-.053 2.106-.889.63-.637.834-2.085.834-2.085s.21-1.7.21-3.399v-1.593a31.8 31.8 0 00-.21-3.398zm-12.457 6.922l-.002-5.901 5.675 2.961-5.674 2.94z"
                fill="currentColor"
              ></path>
            </svg>
          </a>
          <a
            href="https://twitter.com/AudideMexico"
            target="_blank"
            rel="noreferrer"
          >
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M25.55 12.364c.982.177 1.993.12 2.95-.165a11.638 11.638 0 00-3.01 2.183 11.31 11.31 0 01-9.144 11.903 14.601 14.601 0 01-8.846-2.36s3.933 1.062 6.104-1.34c0 0-3.696.337-4.581-2.52a11.242 11.242 0 002.58-.364 4.197 4.197 0 01-3.413-4.115 4.05 4.05 0 001.928.515s-2.857-2.58-1.087-5.607c0 0 3.829 4.675 8.571 4.407a4.077 4.077 0 016.855-3.871 6.393 6.393 0 002.773-1.335 3.547 3.547 0 01-1.68 2.67z"
                fill="currentColor"
              ></path>
            </svg>
          </a>
          <a
            href="https://es.pinterest.com/audidemexico/"
            target="_blank"
            rel="noreferrer"
          >
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.492 7.5c-5.73 0-8.62 4.11-8.62 7.536 0 2.075.786 3.92 2.47 4.608.276.113.524.003.603-.303.056-.21.188-.745.248-.967.079-.303.048-.408-.175-.672-.486-.573-.795-1.316-.795-2.366 0-3.048 2.28-5.778 5.937-5.778 3.24 0 5.02 1.98 5.02 4.623 0 3.479-1.54 6.414-3.825 6.414-1.26 0-2.206-1.044-1.902-2.325.361-1.527 1.064-3.175 1.064-4.28 0-.986-.53-1.81-1.627-1.81-1.29 0-2.325 1.335-2.325 3.122 0 1.14.384 1.91.384 1.91l-1.554 6.572c-.46 1.95-.069 4.343-.036 4.584.02.143.204.177.287.07.12-.157 1.655-2.054 2.177-3.949.149-.537.85-3.315.85-3.315.42.8 1.644 1.503 2.946 1.503 3.877 0 6.51-3.535 6.51-8.266-.002-3.58-3.032-6.91-7.639-6.91h.002z"
                fill="currentColor"
              ></path>
            </svg>
          </a>
        </div>
      </div>

      <div className="c-copyright">
        <span>
          © {new Date().getFullYear()} AUDI AG. Todos los derechos reservados.
        </span>
        <div>
          <ul>
            <li>
              <a href="https://www.audi.com.mx/es/dealer-locator-one/dealer-search-one/">
                Concesionarios
              </a>
            </li>
            <li>
              <a
                href="https://audinewsletter.com.mx/"
                target="_blank"
                rel="noreferrer"
              >
                E-Newsletter
              </a>
            </li>
            <li>
              <a href="https://www.audi.com.mx/es/servicios-al-cliente/Audi_Financial_Services/">
                Audi Financial Services
              </a>
            </li>
            <li>
              <a href="https://www.audi.com.mx/es/servicios-al-cliente/certificaciones/">
                Certificaciones
              </a>
            </li>
            <li>
              <a href="https://www.audi.com.mx/es/tools/navigation/layer/legal/">
                Aviso de privacidad
              </a>
            </li>
            <li>
              <a href="https://www.audi.com.mx/es/tools/navigation/layer/imprint/">
                Aspectos legales
              </a>
            </li>
            <li>
              <a href="https://www.audi.com.mx/es/tools/navigation/layer/terminos_y_condiciones/">
                Términos y condiciones
              </a>
            </li>
            <li>
              <a href="https://www.audi.com.mx/es/tools/navigation/layer/cookies/">
                Política de Cookies
              </a>
            </li>
            <li>
              <a
                href="https://www.audi.com.mx/es/tools/navigation/layer/declaracion-de-derechos-humanos/"
                target="_blank"
                rel="noreferrer"
              >
                Declaratoria de Derechos Humanos
              </a>
            </li>
          </ul>
        </div>
      </div>

      <p>
        <span>
          Términos y condiciones por Audi de México.
          <br />
          Este sitio es oficial de Volkswagen de México, S.A. de C.V.,
          comercializador de marca Audi en México; la información aquí referida,
          así como las ilustraciones de este sitio están de acuerdo a las
          versiones y equipamientos ofertados por el proveedor dentro de la
          República Mexicana y son las más recientes en el momento de hacer esta
          publicación. Algunas versiones y equipamientos son opcionales, por lo
          que los costos de los vehículos aquí ofertados pueden variar y podrían
          tener un costo extra. Los valores obtenidos sobre rendimientos en
          Ciudad, carretera y combinado son valores obtenidos en pruebas de
          laboratorio bajo condiciones controladas. Para conocer la
          disponibilidad de nuestros productos y para mayor información se
          recomienda acudir a su Distribuidor autorizado Audi dentro de la
          República Mexicana.
        </span>
      </p>
    </footer>
  );
};

export default Footer;
